// extracted by mini-css-extract-plugin
export var alt = "Title-module--alt--40ef5";
export var desktopOnly = "Title-module--desktopOnly--8d29f";
export var main = "Title-module--main--08446";
export var mobileOnly = "Title-module--mobileOnly--eebcf";
export var styledH1 = "Title-module--styledH1--7b35e";
export var textLeft = "Title-module--textLeft--ecb46";
export var visuallyHidden = "Title-module--visuallyHidden--970ee";